import React, { useState } from "react";
import {
  Card,
  CardContent,
  Stack,
  Typography,
  FormControlLabel,
  Switch,
} from "@mui/material";

const AiToggleSettings = ({ activeMenu }) => {
  const [aiSubscriptions, setAiSubscriptions] = useState({
    talkToLeads: false,
    autoReply: false,
  });

  const subMap = {
    talk: "talkToLeads",
    auto: "autoReply",
  };

  const subId = subMap[activeMenu];
  const isActive = aiSubscriptions[subId];

  const handleAiToggle = () => {
    setAiSubscriptions((prev) => ({
      ...prev,
      [subId]: !prev[subId],
    }));
  };

  return (
    <Card variant="outlined">
      <CardContent>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="subtitle1" fontWeight="medium">
            Enable {activeMenu === "talk" ? "Talk to Leads" : "Auto Reply"}
          </Typography>
          <FormControlLabel
            control={
              <Switch
                checked={isActive || false}
                onChange={handleAiToggle}
                color="success"
              />
            }
            label={isActive ? "Active" : "Inactive"}
          />
        </Stack>
      </CardContent>
    </Card>
  );
};

export default AiToggleSettings;
